// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeNotificationSettingsSetQuietHoursBody = {
  isEnabled: boolean;
  startMinute: number;
  endMinute: number;
  timeZone: string;
};

export type typeNotificationSettingsSetQuietHoursOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    isEnabled: boolean;
    startMinute: number;
    endMinute: number;
    timeZone: string;
  };
};

export type typeNotificationSettingsSetQuietHoursOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetQuietHoursOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsSetQuietHoursOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaNotificationSettingsSetQuietHoursBody = {
  type: "object",
  properties: {
    isEnabled: { type: "boolean" },
    startMinute: { type: "integer" },
    endMinute: { type: "integer" },
    timeZone: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["isEnabled", "startMinute", "endMinute", "timeZone"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createNotificationSettingsSetQuietHours(
  options: SdkOptions,
) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(
      schemaNotificationSettingsSetQuietHoursBody,
    );
  }

  return async function postNotificationSettingsSetQuietHours(
    payload: typeNotificationSettingsSetQuietHoursBody,
  ): Promise<
    | typeNotificationSettingsSetQuietHoursOutput200
    | typeNotificationSettingsSetQuietHoursOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postNotificationSettingsSetQuietHours" failed before calling the network. #2b3acbc2661f`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#2b3acbc2661f" },
        },
        data: null,
      } as typeNotificationSettingsSetQuietHoursOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/notification-settings/set-quiet-hours`,
      httpMethod: "POST",
      options,
    })) as
      | typeNotificationSettingsSetQuietHoursOutput200
      | typeNotificationSettingsSetQuietHoursOutput400;
  };
}
